import { useContext, useState, useEffect, useCallback, useMemo } from 'react';
import "./command-viewer.scss"
import { ThreeDots } from 'react-loader-spinner'
import { postCommandResult } from './api-requests';
import { AccountContext } from '../context/account-context';
import { CompleteContext } from '../context/complete-context';


const CommandViewer = ({ taskID, senderID, commands }) => {

    const [account, setAccount] = useContext(AccountContext);
    const [complete, setComplete] = useContext(CompleteContext);
    const [buttons, setButtons] = useState([]);
    
    useEffect(()=>{
        setButtons(commands.map(command => ({ ...command, error: false, isProceed: false })));
    }, [commands])

    const handleCommandClick = async (index) => {

        const confirm = commands[index].name ? commands[index].name : "завершити";

        if (window.confirm("Ви впевнені що хочете,  " + confirm + ' ?')) {

            setButtons(prevButtons => {
                const updButtons = [...prevButtons];
                updButtons[index] = { ...updButtons[index], isProceed: true };
                return updButtons;
            });

            await postCommandResult(taskID, commands[index].id);

            if (commands[index].isCompleteCommand){
                setComplete([{id: taskID, isPostComplete: false}]);
            }

            setButtons(prevButtons => {
                const updButtons = [...prevButtons];
                updButtons[index] = { ...updButtons[index], isProceed: false };
                return updButtons;
            });
        }
    };


    //const onChange = useCallback((id, value) => {
    //    setImages(prevItems => prevItems.map((item, index) => {
    //        return index !== id ? item : { value: value }
    //    }))
    //}, [])

    if (!buttons || !buttons.length)
        return <></>

    return (
        <div className={buttons && buttons.length > 1 ? "command-viewer" : "command-viewer-single"}>

            {buttons.map((button, index) => {

                if (button.isCompleteCommand || button.isHot) {

                    return (

                        <div key={index}>
                            <button onClick={() => handleCommandClick(index, button.id, button.name)} disabled={buttons.length && buttons[index].isProceed}

                            >{buttons.length && buttons[index].isProceed ? '' : button.isCompleteCommand && !button.name ? "Завершити" : button.name}

                                <ThreeDots height={"100%"}
                                    width="50"
                                    radius="5"
                                    color="white"
                                    visible={buttons.length && buttons[index].isProceed}
                                >
                                </ThreeDots>

                            </button>
                        </div>
                    )
                }
            })
            }

        </div>
    );
};

export default CommandViewer;



